import { Row, RowCenter } from "style/preset";
import StyledContainer from "style/styledContainer";
import styled from "styled-components";
import Switch from "react-switch";
import DrawerAddressCom from "./Drawer/DrawerAddressCom";
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks";
import { setOpenToAddressWin } from "hooks/redux/slices/appSlice";
import { useEffect, useState } from "react";
import { setIsAnotherToAddress, setToAddress } from "hooks/redux/slices/coreInfoSlice";
import { shortStr } from "utils";

const FunListCom = () => {
    const [switchOpen, setSwitchOpen] = useState(false)
    const {openToAddressWin} = useAppSelector((state) => state.app)
    const { toAddress } = useAppSelector((state) => state.coreInfo)
    const dispatch = useAppDispatch()

    const fnSwitchOpen = (isOpen: boolean) => {
        setSwitchOpen(isOpen)
        dispatch(setIsAnotherToAddress(isOpen))
        if(!toAddress && isOpen) {
            dispatch(setOpenToAddressWin(true))
        }
        if(!isOpen) {
            dispatch(setToAddress(''))
        }
    }

    useEffect(() => {
        if(!openToAddressWin && !toAddress) {
            setSwitchOpen(false)
        }
    }, [openToAddressWin, toAddress])

    return <StyledContainer>
        <FunListWrap>
            <FunItemWrap $isBorder={true} $flexDirection="column">
                <Row $width="100%" $justifyContent="space-between">
                    <FunItemLabelWrap>Send the output assets to another address?</FunItemLabelWrap>
                    <Switch
                        checked={switchOpen}
                        onChange={fnSwitchOpen}
                        handleDiameter={20}
                        offColor="#F2F2F2"
                        onColor="#0A0A0A"
                        offHandleColor="#FFFFFF"
                        onHandleColor="#FFFFFF"
                        height={24}
                        width={54}
                        borderRadius={16}
                        activeBoxShadow=""
                        uncheckedIcon={<UncheckedIconWrap>No</UncheckedIconWrap>}
                        checkedIcon={<CheckedIconWrap $ml="6px">Yes</CheckedIconWrap>}
                        uncheckedHandleIcon={<HandleIconWrap></HandleIconWrap>}
                        checkedHandleIcon={<HandleIconWrap></HandleIconWrap>}
                        className="chainge_switch_btn"
                    />
                </Row>
                {
                    !!toAddress && <AnotherAddressWrap $mt="20px">
                        <Row>
                            <StyledContainer $fontWeight6 $roobertSemiBold>Will be sent to:</StyledContainer>
                            <StyledContainer $fontWeight5 $ml="8px">{shortStr(toAddress)}</StyledContainer>
                        </Row>
                        <StyledContainer $pointer $color="#4D1DF7" $roobertSemiBold onClick={() => dispatch(setOpenToAddressWin(true))}>Edit</StyledContainer>
                    </AnotherAddressWrap>
                }
            </FunItemWrap>
            <FunItemWrap>
                <FunItemLabelWrap>Will this be a limit order?</FunItemLabelWrap>
                <ComingSoonWrap $roobertRegular>Available on Feb 28, 2024</ComingSoonWrap>
            </FunItemWrap>
        </FunListWrap>
        <DrawerAddressCom open={openToAddressWin} closeChange={(isClosed) => dispatch(setOpenToAddressWin(isClosed))}></DrawerAddressCom>
    </StyledContainer>;
}

const FunListWrap = styled(StyledContainer)`
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);
    overflow: hidden;
    background-color: ${({theme}) => theme.basicWhite};
    border-radius: 9px;
`

const FunItemWrap = styled(Row)<{$isBorder: boolean}>`
    justify-content: space-between;
    padding: 15px 20px;
    border-bottom: ${({$isBorder}) => $isBorder ? '1px solid #F2F2F2': 'none'};
    
`

const FunItemLabelWrap = styled(StyledContainer)`
    font-size: 14px;
    line-height: 16px;
`

const HandleIconWrap = styled(RowCenter)`
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #ffffff;
`

const CheckedIconWrap = styled(RowCenter)`
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    
    color: ${({theme}) => theme.basicWhite};
`

const UncheckedIconWrap = styled(CheckedIconWrap)`
    color: ${({theme}) => theme.lightBlack};   
`


const ComingSoonWrap = styled(StyledContainer)`
    font-size: 12px;
    line-height: 14px;
    padding: 4px 8px;
    color: ${({theme}) => theme.lightBlack};
    background-color: #F6F5F4;
    border-radius: 4px;
`

const AnotherAddressWrap = styled(Row)`
    background-color: #F6F5F4;
    padding: 6px 8px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 14px;
    width: 100%;
    justify-content: space-between;
`
export default FunListCom